import React, { useEffect, useMemo, useState } from 'react'
import { config } from './../Init/Init'
import moment from 'moment'
import l10n from '../i18n/I18N'
import { tokenizer } from '../../services/utils'

const Countdown = ({ deadline, timerText, expiredText }) => {
  const parsedDeadline = useMemo(() => Date.parse(deadline), [])
  const expiredDate = useMemo(() => new Date(parsedDeadline).toLocaleDateString(l10n.browserDateLocale()), [])
  const [duration, setDuration] = useState(moment.duration(parsedDeadline - Date.now(), 'milliseconds'))
  const [timeString, setTimeString] = useState('')

  useEffect(() => {
    const interval = setInterval(
      () => setDuration(moment.duration(parsedDeadline - Date.now(), 'milliseconds')),
      config.secondMultiplier
    )

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    setTimeString(
      tokenizer(
        l10n.t['lobby.bannerTimer'].substring(duration.days() > 0 ? 0 : l10n.t['lobby.bannerTimer'].indexOf('{H}')),
        {
          '{D}': `${Math.floor(duration.asDays())}`,
          '{H}': `${duration.hours()}`,
          '{M}': `${duration.minutes()}`,
          '{S}': `${duration.seconds()}`
        }
      )
    )
  }, [duration])

  return <>{duration > 0 ? `${timerText} ${timeString}` : `${expiredText} ${expiredDate}`}</>
}

export default Countdown
